module.exports = __webpack_public_path__ + "img/partner7.cd0f7941.png";